import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './keycloak-update-password.magic.css.js';
import script from './keycloak-update-password.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{ref:"update-password-form",staticStyle:{"display":"none"},attrs:{"action":_vm.updatePasswordAction,"method":"post"}},[_c('input',{attrs:{"type":"password","id":"password-new","name":"password-new","autocomplete":"off"}}),_vm._v(" "),_c('input',{attrs:{"type":"password","id":"password-confirm","name":"password-confirm","autocomplete":"off"}})]),_vm._v(" "),_c('magic-ui-peek-password',{attrs:{"type":"password","pattern":".*","inputmode":"text","message":_vm.$t('reset-password-form.new-password.error'),"has-success":!_vm.$v.password.$invalid,"has-error":_vm.$v.password.$error,"placeholder":_vm.$t('reset-password-form.new-password.placeholder'),"value":(_vm.$v.password.$model)},on:{"blur":function($event){return _vm.$v.password.$touch()},"input":function($event){return _vm.$set(_vm.$v.password, "$model", $event.detail[0])}}}),_vm._v(" "),_c('magic-ui-peek-password',{attrs:{"type":"password","pattern":".*","inputmode":"text","message":_vm.$t(_vm.repeatPasswordError),"has-success":!_vm.$v.repeatPassword.$invalid,"has-error":_vm.$v.repeatPassword.$error,"placeholder":_vm.$t('reset-password-form.confirm-password.placeholder'),"value":(_vm.$v.repeatPassword.$model)},on:{"blur":function($event){return _vm.$v.repeatPassword.$touch()},"input":function($event){return _vm.$set(_vm.$v.repeatPassword, "$model", $event.detail[0])}}}),_vm._v(" "),_c('div',{staticClass:"wrapper",attrs:{"part":"wrapper"}},[_c('magic-ui-link',{attrs:{"href":_vm.backToLoginUrl}},[_c('magic-ui-button',{attrs:{"wide":"","hollow":"","variant":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('update-password.action.back-to-login'))}})],1),_vm._v(" "),_c('magic-ui-button',{attrs:{"wide":"","variant":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('update-password.action.update'))},on:{"click":_vm.submit}})],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1e340856_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-1e340856";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
